@if ((activityIsHighlighted$ | async) || isOnAPinbord) {
  <div class="left-side-items">
    <mat-icon [matTooltip]="'activity.card.highlighted' | translate">star</mat-icon>
  </div>
}

<div class="right-side-items">
  @if (activityActions$ | async; as activityActions) {
    <div class="activity-actions">
      @if (activityActions.length > 0) {
        <button mat-icon-button (click)="openActionsMenu($event)"><mat-icon>more_vert</mat-icon></button>
      }
      <div class="invisible-trigger" [matMenuTriggerFor]="menu"></div>
      <mat-menu #menu="matMenu" class="activity-action-menu">
        @for (activityAction of activityActions; track activityAction) {
          <button (click)="executeActivityAction(activityAction)" mat-menu-item>
            <span>{{ 'activity.card.action.' + activityAction | translate }}</span>
          </button>
        }
      </mat-menu>
    </div>
  }
</div>

<mat-card [id]="'activity-' + activity.id" class="activity-card publication-status-{{ activity.status_id }}" @fadeInOut>
  <div class="image-container">
    <app-doenkids-image (loaded)="imageLoaded()" [mediaItem]="{ uuid: activity.media_uuid, description: '' }" [preview]="true"></app-doenkids-image>
    <div class="activity-banners">
      @if ((isImproved$ | async)) {
        <div class="activity-banner">
          <span>{{ 'activity.card.improved' | translate }}</span>
        </div>
      }
      @if ((isPendingRemoval$ | async)) {
        <div class="activity-banner pending-removal-banner">
          <span>{{ 'activity.card.pending_removal' | translate }}</span>
        </div>
      }
      @if ((isNew$ | async)) {
        <div class="activity-banner activity-new-banner">
          <span>{{ 'activity.card.new' | translate }}!</span>
        </div>
      }
      @if ((isOriginalDeleted$ | async) && !(isReader$ | async) && (!(isDKCountryRoot$ | async) || (isAdmin$ | async))) {
        <div class="activity-banner activity-outdated-banner">
          <span [matTooltip]="'activity.outdated.deleted.description' | translate">{{ 'activity.card.outdated.deleted' | translate }}</span>
        </div>
      }
      @if ((isOriginalUpdatedOnly$ | async) && !(isReader$ | async) && (!(isDKCountryRoot$ | async) || (isAdmin$ | async))) {
        <div class="activity-banner activity-outdated-banner">
          <span [matTooltip]="'activity.outdated.updated.description' | translate">{{ 'activity.card.outdated.updated' | translate }}</span>
        </div>
      }
    </div>
  </div>
  @if ((shouldShowActivityIsCopy$ | async)) {
    <div
      class="activity-copy-indicator"
      >
      @if ((shouldShowCountryFlag$ | async)) {
        <mat-icon [svgIcon]="activity.language"></mat-icon>
      }
      <mat-chip-set aria-label="Copied activity indicator">
        <mat-chip class="chip-copy">{{ 'generic.is_copy' | translate }}</mat-chip>
      </mat-chip-set>
    </div>
  }
  <div class="text-container">
    <h2 class="activity-title">
      @if ((shouldShowCountryFlag$ | async) && !(shouldShowActivityIsCopy$ | async)) {
        <mat-icon [svgIcon]="activity.language"></mat-icon>&nbsp;
      }
      {{ activity.name !== '' ? activity.name : ('activity.card.new' | translate) }}
    </h2>
    <h3>
      {{ activity.subtitle }}
    </h3>
    <p>{{ activity.summary | truncate: 200 }}</p>
  </div>
  @if (activityCreatedByOU || activityCreatedByUser) {
    <div class="text-disclaimer">
      @if (activityCreatedByOU) {
        <span
          [innerHtml]="'activity.card.created_by_organization' | translate: { organization: activityCreatedByOU, user: activityCreatedByUser || undefined }"
          >
        </span>
      }
      @if (!activityCreatedByOU) {
        <span [innerHtml]="'activity.card.created_by_user' | translate: { user: activityCreatedByUser }"></span>
      }
    </div>
  }
</mat-card>
